/*
 * @Author: chengyunxiao
 * @Date: 2023-06-01 20:49:30
 * @LastEditTime: 2024-08-23 17:44:01
 * @Description: Do not eidt
 */
import { Toast } from '@atom/atom-ui';
import { isThsLogin } from '@king-fisher/khxtzsq-business';
import { StatusCode } from '../utils/enums';
import { requestDynamic, requestTj } from '../utils/https';
import { LOGIN_ID, MISSION_ID, POINT_TYPE, SENCE_ID, USER_ACTION } from '../utils/const';
import request from '@/utils/request';
import type { Result } from '@/types/data';

// 获取动态运营配置
export const getDynamicConfig = async (params?: { key: string }): Promise<Result<{ [key: string]: any[] }>> => {
  const result = await requestDynamic.get('', { params });
  if (result.statusCode !== StatusCode.SUCCESS_CODE) {
    Toast(result.statusMsg);
  }
  return result;
};

export const getScoreInfo = async () => {
  const NORMAL_OBJ = {
    pointAmount: 0,
    userId: isThsLogin() ? window.getUserid() : '',
  };
  try {
    const result = await requestTj.get('/points/user/v1/point', {
      params: { sceneId: SENCE_ID, pointType: POINT_TYPE },
    });
    if (result.statusCode !== StatusCode.SUCCESS_CODE) {
      Toast(result.statusMsg);
      return Promise.resolve(NORMAL_OBJ);
    }
    return Promise.resolve(Object.assign(NORMAL_OBJ, result.data));
  } catch {
    return Promise.resolve(NORMAL_OBJ);
  }
};

export const getStatus = async params => {
  const TASK_ID = params.userAction === USER_ACTION ? MISSION_ID : LOGIN_ID;
  const result = await requestTj.get('/center/task/progress/v1/get_status', {
    params: { sceneId: SENCE_ID, taskId: TASK_ID },
  });
  return (result.statusCode === StatusCode.SUCCESS_CODE && result.data) || false;
};

// 加积分，失败无感
export const doScore = async (params = { sceneId: SENCE_ID, userAction: USER_ACTION }) => {
  const status = await getStatus(params);
  if (status) {
    return false;
  }
  const result = await requestTj.get('/center/task/progress/v1/send', {
    params,
  });
  if (result.statusCode !== StatusCode.SUCCESS_CODE) {
    Toast(result.statusMsg);
    return false;
  }
  return true;
};

// 情绪数据 demo
export const getHomeEmotion = (params: any) =>
  request.get('https://cyx.10jqka.com.cn/content/report/research_report/v2/report/yunying/grid/get', { params });
